import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-table-preloading',
    templateUrl: './table-preloading.component.html',
    styleUrls: ['./table-preloading.component.scss'],
    standalone: false
})
export class TablePreloadingComponent implements OnInit {

  @Input() row: number = 1;
  @Input() col: number = 3;
  @Input() colSize: number = 4;

  rowArray = [];
  colArray = [];

  constructor() { }

  ngOnInit() {
    this.rowArray = [...Array(this.row).keys()]
    this.colArray = [...Array(this.col).keys()]
  }

}
